let extCartDataURL = 'https://api3.lotte-dutyfree.com.au/cart-datas/cart-data-ms.php';
let secondaryCartDataURL = 'https://orders.lotte-dutyfree.com.au/cart-datas/cart-data-ms.php';
let thirdCartDataURL = 'https://order.lotte-dutyfree.com.au/cart-datas/cart-data-ms.php';

let checkSessionFormData = new FormData();
let saveCartTokenFormData = new FormData();
let saveCartTokenData = new FormData();


/***********  ***********/
/*********** Check if User cookie exist ***********/
let getUserCookie = getCookie('userCookie');
let getCartDataFilledCookie = getCookie('dataFilled');
if( getCartDataFilledCookie == 'yes' ) {
	document.querySelector('#shopify-section-cart-data-sticky').classList.add('already-filled');
}
//alert(getUserCookie);

/*********** If userCookie not empty ***********/
if( getUserCookie != '' ) {
	let checkSessionCookieFormData = new FormData();
	checkSessionCookieFormData.append("session_cookie", getUserCookie);
	checkSessionCookieFormData.append("type", "check-session-cookie");
	try {
		fetch(extCartDataURL, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
			},
			body: checkSessionCookieFormData
		}).then(response => response.json())
		.then(function (response) {
			const cartData = response;
			if( response.session_data_available == 'no' ) {
				setCookieExpiry('dataFilled', '', 0);
				document.querySelector('#shopify-section-cart-data-sticky').classList.remove('already-filled');
				generateUniqueString();
			} else if( response.session_data_available == 'yes' ) {
				checkUserCart(getUserCookie);
			}
		}).catch(error => {
			fetch(secondaryCartDataURL, { 
				method: 'POST',
				headers: {
					'Accept': 'application/json',
				},
				body: checkSessionCookieFormData
			}).then(response => response.json())
			.then(function (response) {
				const cartData = response;
				if( response.session_data_available == 'no' ) {
					setCookieExpiry('dataFilled', '', 0);
					document.querySelector('#shopify-section-cart-data-sticky').classList.remove('already-filled');
					generateUniqueString();
				} else if( response.session_data_available == 'yes' ) {
					checkUserCart(getUserCookie);
				}
			}).catch(error => {
				fetch(thirdCartDataURL, { 
					method: 'POST',
					headers: {
						'Accept': 'application/json',
					},
					body: checkSessionCookieFormData
				}).then(response => response.json())
				.then(function (response) {
					const cartData = response;
					if( response.session_data_available == 'no' ) {
						setCookieExpiry('dataFilled', '', 0);
						document.querySelector('#shopify-section-cart-data-sticky').classList.remove('already-filled');
						generateUniqueString();
					} else if( response.session_data_available == 'yes' ) {
						checkUserCart(getUserCookie);
					}
				});
			});
		});
	} catch(err) {
		fetch(extCartDataURL, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
			},
			body: checkSessionCookieFormData
		}).then(response => response.json())
		.then(function (response) {
			const cartData = response;
			if( response.session_data_available == 'no' ) {
				setCookieExpiry('dataFilled', '', 0);
				document.querySelector('#shopify-section-cart-data-sticky').classList.remove('already-filled');
				generateUniqueString();
			} else if( response.session_data_available == 'yes' ) {
				checkUserCart(getUserCookie);
			}
		}).catch(error => {
			fetch(secondaryCartDataURL, { 
				method: 'POST',
				headers: {
					'Accept': 'application/json',
				},
				body: checkSessionCookieFormData
			}).then(response => response.json())
			.then(function (response) {
				const cartData = response;
				if( response.session_data_available == 'no' ) {
					setCookieExpiry('dataFilled', '', 0);
					document.querySelector('#shopify-section-cart-data-sticky').classList.remove('already-filled');
					generateUniqueString();
				} else if( response.session_data_available == 'yes' ) {
					checkUserCart(getUserCookie);
				}
			}).catch(error => {
				fetch(thirdCartDataURL, { 
					method: 'POST',
					headers: {
						'Accept': 'application/json',
					},
					body: checkSessionCookieFormData
				}).then(response => response.json())
				.then(function (response) {
					const cartData = response;
					if( response.session_data_available == 'no' ) {
						setCookieExpiry('dataFilled', '', 0);
						document.querySelector('#shopify-section-cart-data-sticky').classList.remove('already-filled');
						generateUniqueString();
					} else if( response.session_data_available == 'yes' ) {
						checkUserCart(getUserCookie);
					}
				});
			});
		});
	}
} else {
	/*********** If userCookie empty ***********/
	generateUniqueString();
}

/*let pickupLocation = document.querySelectorAll('input.pickup-location[type="radio"]');
let selectedPickupLocation = '';
let travellerName = document.querySelector('#traveller-name');
let portOfDep = document.querySelector('#port-of-departure');
let flightNumber = document.querySelector('#flight-number');
let passportNumber = document.querySelector('#passport-number');
let phoneNumber = document.querySelector('#phone-number');
let collectionHour = document.querySelector('#collection-hour');
let collectionMin = document.querySelector('#collection-minute');
let flightDate = document.querySelector('#flight-date');
let checkoutButton = document.querySelector('.validate_cart_button');
let checkoutCreationButton = document.querySelector('.cart__submit');*/

function removeSpecialChars(el) {
	el.value = el.value.replace(/[^A-Za-z0-9 ]/g,'');
}

function removePhoneSpecialChars(el) {
	el.value = el.value.replace(/[^0-9]/g,'');
}

function allowOnlyAlpha(el) {
	el.value = el.value.replace(/[^A-Za-z ]/g,'');
}

/*function changePickupLocation(el) {
	document.querySelector('.location-label').classList.remove('error');
	saveValidCartData();
}*/

function changeTravellerName(el) {
	document.querySelector('.traveller-label').classList.remove('error');
	el.value = el.value.replace(/[^A-Za-z ]/g,'');
	saveValidCartData();
}

function changePortOfDep(el) {
	document.querySelector('.port-label').classList.remove('error');
	el.value = el.value.replace(/[^A-Za-z0-9 ]/g,'');
	saveValidCartData();
}

function changeFlightNumber(el) {
	document.querySelector('.flight-label').classList.remove('error');
	el.value = el.value.replace(/[^a-z0-9]/gi,'');
	saveValidCartData();
}

function changePassportNumber(el) {
	document.querySelector('.passport-label').classList.remove('error');
	el.value = el.value.replace(/[^a-z0-9]/gi,'');
	saveValidCartData();
}

function changePhoneNumber(el) {
	document.querySelector('.phone-label').classList.remove('error');
	el.value = el.value.replace(/[^0-9]/g,'');
	saveValidCartData();
}

function changeFlightDate(el) {
	document.querySelector('.flight-date-label').classList.remove('error');
	setTimeout(function(){
		const getFlightDateInterval = setInterval(function(){
			let flightDate = el.value;
			let collectionDate = document.querySelector('#collection-date');
			if( flightDate != '' ) {
				clearInterval(getFlightDateInterval);
				var checkDateOK = checkFCDate(flightDate, collectionDate.value);
				if( !checkDateOK ) {
					//Do Nothing.
				} else {
					saveValidCartData();
				}
			}
		}, 50);
	}, 50);
}

function changeCollectionDate(el) {
	setTimeout(function(){
		const getCollectionDateInterval = setInterval(function(){
			let collectionDate = el.value;
			let flightDate = document.querySelector('#flight-date');
			if( collectionDate != '' ) {
				clearInterval(getCollectionDateInterval);
				var checkDateOK = checkFCDate(flightDate.value, collectionDate);
				if( !checkDateOK ) {
					//Do Nothing.
				} else {
					saveValidCartData();
				}
			}
		}, 50);
	}, 50);
}

function changeCollectionHour(el) {
	document.querySelector('.collection-label').classList.remove('error');
	saveValidCartData();
}

function changeCollectionMin(el) {
	document.querySelector('.collection-label').classList.remove('error');
	saveValidCartData();
}
document.addEventListener("DOMContentLoaded", function() {
	let myCartModalEl = document.getElementById('cartDataModal')
	myCartModalEl.addEventListener('hidden.bs.modal', function (event) {
		document.querySelector('.cart-form-save-error-wrapper').textContent = '';
		document.querySelector('.cart-form-save-error-wrapper').classList.remove('error');
		document.querySelector('.cart-form-save-error-wrapper').classList.remove('success');
		document.querySelector('.title-label').classList.remove('error');
	})
})

function checkFCDate(fDate, cDate) {
	const today = new Date();
	const tomorrow = new Date(today);
	const collectionCheckDate = new Date(cDate);
	const flightCheckDate = new Date(fDate);
	
	tomorrow.setDate(tomorrow.getDate() + 1);
	tomorrow.setHours(0);
	tomorrow.setMinutes(0);
	tomorrow.setSeconds(0);
	tomorrow.setMilliseconds(0);
	
	flightCheckDate.setHours(0);
	flightCheckDate.setMinutes(0);
	flightCheckDate.setSeconds(0);
	flightCheckDate.setMilliseconds(0);
	
	collectionCheckDate.setHours(0);
	collectionCheckDate.setMinutes(0);
	collectionCheckDate.setSeconds(0);
	collectionCheckDate.setMilliseconds(0);
	
	var tomorrowDate = tomorrow.toISOString().slice(0, 10);
	var tomorrowDateStrTime = (Date.parse(tomorrowDate) / 1000);
	
	var collectionCheckDateStrTime = (Date.parse(collectionCheckDate) / 1000);
	var flightCheckDateStrTime = (Date.parse(flightCheckDate) / 1000);
	
	var checkFCDatePassed = true;
	
	if (flightCheckDateStrTime < tomorrowDateStrTime){
		checkFCDatePassed = false;
	} else {
		checkFCDatePassed = true;
	}
	if (collectionCheckDateStrTime < tomorrowDateStrTime){
		checkFCDatePassed = false;
	} else {
		checkFCDatePassed = true;
	}		
	if (flightCheckDate < collectionCheckDate){
		checkFCDatePassed = false;
	} else {
		checkFCDatePassed = true;
	}
	return checkFCDatePassed;
}

function saveCartDataValues() {
	/*let pickupLocation = document.querySelectorAll('input.pickup-location[type="radio"]:checked');
	let selectedLocation = document.querySelectorAll('input.pickup-location[type="radio"]');
	for (i = 0; i < selectedLocation.length; i++) {
        if (selectedLocation[i].checked) {
			selectedLocationVal = selectedLocation[i].value;
		}
	}*/
	let travellerName = document.querySelector('#traveller-name');
	let portOfDep = document.querySelector('#port-of-departure');
	let flightNumber = document.querySelector('#flight-number');
	let passportNumber = document.querySelector('#passport-number');
	let phoneNumber = document.querySelector('#phone-number');
	let collectionHour = document.querySelector('#collection-hour');
	let collectionMin = document.querySelector('#collection-minute');
	let flightDate = document.querySelector('#flight-date');
	let collectionDate = document.querySelector('#collection-date');
	
	let collectionCheckDate  = new Date(collectionDate.value);
	let flightCheckDate  = new Date(flightDate.value);
	
	const today = new Date();
	const tomorrow = new Date(today);
	const collectionCheckDateD = new Date(collectionCheckDate);
	const flightCheckDateD = new Date(flightCheckDate);
	tomorrow.setDate(tomorrow.getDate() + 1);
	tomorrow.setHours(0);
	tomorrow.setMinutes(0);
	tomorrow.setSeconds(0);
	tomorrow.setMilliseconds(0);
		
	flightCheckDateD.setHours(0);
	flightCheckDateD.setMinutes(0);
	flightCheckDateD.setSeconds(0);
	flightCheckDateD.setMilliseconds(0);
		
	collectionCheckDateD.setHours(0);
	collectionCheckDateD.setMinutes(0);
	collectionCheckDateD.setSeconds(0);
	collectionCheckDateD.setMilliseconds(0);
		
	var tomorrowDate = tomorrow.toISOString().slice(0, 10);
	var tomorrowDateStrTime = (Date.parse(tomorrowDate) / 1000);
		
	var collectionCheckDateStrTime = (Date.parse(collectionCheckDateD) / 1000);
	var flightCheckDateStrTime = (Date.parse(flightCheckDateD) / 1000);
	
	let formError = false;
	
	/*if( pickupLocation.length === 0 ) {
		document.querySelector('.location-label').classList.add('error');
		formError = true;
	} else {
		document.querySelector('.location-label').classList.remove('error');
	}*/
	
	if( travellerName.value == '' ) {
		document.querySelector('.traveller-label').classList.add('error');
		formError = true;
	} else {
		document.querySelector('.traveller-label').classList.remove('error');
	}
	if( collectionDate.value == '' ) {
		document.querySelector('.collection-date-label').classList.add('error');
		formError = true;
	} else {
		document.querySelector('.collection-date-label').classList.remove('error');
	}
	if( collectionHour.value == '' ) {
		document.querySelector('.collection-label').classList.add('error');
		formError = true;
	} else {
		document.querySelector('.collection-label').classList.remove('error');
	}
	if( collectionMin.value == '' ) {
		document.querySelector('.collection-label').classList.add('error');
		formError = true;
	} else {
		document.querySelector('.collection-label').classList.remove('error');
	}
	if( flightDate.value == '' ) {
		document.querySelector('.flight-date-label').classList.add('error');
		formError = true;
	} else {
		document.querySelector('.flight-date-label').classList.remove('error');
	}
	if( portOfDep.value == '' ) {
		document.querySelector('.port-label').classList.add('error');
		formError = true;
	} else {
		document.querySelector('.port-label').classList.remove('error');
	}
	if( flightNumber.value == '' ) {
		document.querySelector('.flight-label').classList.add('error');
		formError = true;
	} else {
		document.querySelector('.flight-label').classList.remove('error');
	}
	if( passportNumber.value == '' ) {
		document.querySelector('.passport-label').classList.add('error');
		formError = true;
	} else {
		document.querySelector('.passport-label').classList.remove('error');
	}
	if( phoneNumber.value == '' ) {
		document.querySelector('.phone-label').classList.add('error');
		formError = true;
	} else {
		document.querySelector('.phone-label').classList.remove('error');
	}
	if( formError ) {
		document.querySelector('.cart-form-save-error-wrapper').textContent = 'Please make sure all fields are filled in correctly.';
		document.querySelector('.cart-form-save-error-wrapper').classList.add('error');
		return false;
	} else {
		setCookieExpiry('dataFilled', 'yes', 2);
		document.querySelector('.save-cart-data-modal').textContent = 'Processing...';
		let cartSToken = getCookie('cart');
		cartSToken = cartSToken.split("?");
		cartSToken = cartSToken[0];
		console.log(cartSToken);
		let savedUserCookie = getCookie('userCookie');
		let saveCartFormData = new FormData();
		saveCartFormData.append("carttoken", cartSToken);
		saveCartFormData.append("session_cookie", savedUserCookie);
		saveCartFormData.append("type", 'save-cart-form-data-popup');
		
		saveCartFormData.append("pickup_location", selectedLocationVal);
		saveCartFormData.append("traveller_name", travellerName.value);
		saveCartFormData.append("port_departure", portOfDep.value);
		saveCartFormData.append("flight_number", flightNumber.value);
		saveCartFormData.append("passport_number", passportNumber.value);
		saveCartFormData.append("phone_number", phoneNumber.value);
		saveCartFormData.append("flight_date", flightDate.value);
		//saveCartFormData.append("collection_date", collectionDate);
		saveCartFormData.append("collection_hour", collectionHour.value);
		saveCartFormData.append("collection_min", collectionMin.value);
		saveCartFormData.append("saved_through", 'popup');
		
		//saveCartData(saveCartFormData);
		try {
			fetch(extCartDataURL, { 
				method: 'POST',
				headers: {
					'Accept': 'application/json',
				},
				body: saveCartFormData
			}).then(response => response.json())
			.then(function (response) {
				document.querySelector('.save-cart-data-modal').textContent = 'Save';
				document.querySelector('.cart-form-save-error-wrapper').textContent = 'Travel details updated.';
				document.querySelector('.cart-form-save-error-wrapper').classList.add('success');
				document.querySelector('#shopify-section-cart-data-sticky').classList.add('already-filled');
			}).catch(error => {
				fetch(secondaryCartDataURL, { 
					method: 'POST',
					headers: {
						'Accept': 'application/json',
					},
					body: saveCartFormData
				}).then(response => response.json())
				.then(function (response) {
					document.querySelector('.save-cart-data-modal').textContent = 'Save';
					document.querySelector('.cart-form-save-error-wrapper').textContent = 'Travel details updated.';
					document.querySelector('.cart-form-save-error-wrapper').classList.add('success');
					document.querySelector('#shopify-section-cart-data-sticky').classList.add('already-filled');
				}).catch(error => {
					fetch(thirdCartDataURL, { 
						method: 'POST',
						headers: {
							'Accept': 'application/json',
						},
						body: saveCartFormData
					}).then(response => response.json())
					.then(function (response) {
						document.querySelector('.save-cart-data-modal').textContent = 'Save';
						document.querySelector('.cart-form-save-error-wrapper').textContent = 'Travel details updated.';
						document.querySelector('.cart-form-save-error-wrapper').classList.add('success');
						document.querySelector('#shopify-section-cart-data-sticky').classList.add('already-filled');
					});
				});
			});
		} catch(err) {
			fetch(extCartDataURL, { 
				method: 'POST',
				headers: {
					'Accept': 'application/json',
				},
				body: saveCartFormData
			}).then(response => response.json())
			.then(function (response) {
				document.querySelector('.save-cart-data-modal').textContent = 'Save';
				document.querySelector('.cart-form-save-error-wrapper').textContent = 'Travel details updated.';
				document.querySelector('.cart-form-save-error-wrapper').classList.add('success');
				document.querySelector('#shopify-section-cart-data-sticky').classList.add('already-filled');
			}).catch(error => {
				fetch(secondaryCartDataURL, { 
					method: 'POST',
					headers: {
						'Accept': 'application/json',
					},
					body: saveCartFormData
				}).then(response => response.json())
				.then(function (response) {
					document.querySelector('.save-cart-data-modal').textContent = 'Save';
					document.querySelector('.cart-form-save-error-wrapper').textContent = 'Travel details updated.';
					document.querySelector('.cart-form-save-error-wrapper').classList.add('success');
					document.querySelector('#shopify-section-cart-data-sticky').classList.add('already-filled');
				}).catch(error => {
					fetch(thirdCartDataURL, { 
						method: 'POST',
						headers: {
							'Accept': 'application/json',
						},
						body: saveCartFormData
					}).then(response => response.json())
					.then(function (response) {
						document.querySelector('.save-cart-data-modal').textContent = 'Save';
						document.querySelector('.cart-form-save-error-wrapper').textContent = 'Travel details updated.';
						document.querySelector('.cart-form-save-error-wrapper').classList.add('success');
						document.querySelector('#shopify-section-cart-data-sticky').classList.add('already-filled');
					});
				});
			});
		}
	}
}

function checkTokenFormCartData(response, uniqueString) {
			const cartData = response;
			let cartToken = getCookie('cart');
			cartToken = cartToken.split("?");
			cartToken = cartToken[0];
			if( response.cart_data_available == 'no' ) {
				//alert('test6');
				
				/*document.getElementById("arrivals").checked = false;
				document.getElementById("departures").checked = false;*/
				document.querySelector('#traveller-name').value = "";
				document.querySelector('#port-of-departure').value = "";
				document.querySelector('#flight-number').value = "";
				document.querySelector('#passport-number').value = "";
				document.querySelector('#phone-number').value = "";
				document.querySelector('#collection-hour').value = "";
				document.querySelector('#collection-minute').value = "";
				document.querySelector('#flight-date').value = "";
				document.querySelector('#collection-date').value = "";
				
				saveCartTokenFormData.append("type", "save-cart-token");
				saveCartTokenFormData.append("carttoken", cartToken);
				saveCartTokenFormData.append("session_cookie", uniqueString);
				saveCartData(saveCartTokenFormData);
				setCookieExpiry('userCookie', uniqueString, 2);
			} else if( response.cart_data_available == 'yes' ) {
				//alert('test7');
				if( response.session_cookie != '' ) {
					//alert('test8');
					setCookieExpiry('userCookie', response.session_cookie, 2);
				} else {
					//alert('test9');
					saveCartTokenFormData.append("type", "update-cart-token-cookie");
					saveCartTokenFormData.append("carttoken", cartToken);
					saveCartTokenFormData.append("session_cookie", uniqueString);
					saveCartData(saveCartTokenFormData);
				}
				/*if( response.pickup_location != '' ) {
					if( response.pickup_location == "1121002" ){
						document.getElementById("arrivals").checked = true;
					}
					if( response.pickup_location == "1121001" ){
						document.getElementById("departures").checked = true;
					}
				} else {
					document.getElementById("arrivals").checked = false;
					document.getElementById("departures").checked = false;
				}*/
				
				if( response.traveller_name != '' ) {
					document.querySelector('#traveller-name').value = response.traveller_name;
				} else {
					document.querySelector('#traveller-name').value = "";
				}
				
				if( response.port_departure != '' ) {
					document.querySelector('#port-of-departure').value = response.port_departure;
				} else {
					document.querySelector('#port-of-departure').value = "";
				}
				
				if( response.flight_number != '' ) {
					document.querySelector('#flight-number').value = response.flight_number;
				} else {
					document.querySelector('#flight-number').value = "";
				}
				
				if( response.passport_number != '' ) {
					document.querySelector('#passport-number').value = response.passport_number;
				} else {
					document.querySelector('#passport-number').value = "";
				}
				
				if( response.phone_number != '' ) {
					document.querySelector('#phone-number').value = response.phone_number;
				} else {
					document.querySelector('#phone-number').value = "";
				}
				
				if( response.collection_hour != '' ) {
					document.querySelector('#collection-hour').value = response.collection_hour;
				} else {
					document.querySelector('#collection-hour').value = "";
				}
				
				if( response.collection_min != '' ) {
					document.querySelector('#collection-minute').value = response.collection_min;
				} else {
					document.querySelector('#collection-minute').value = "";
				}
				
				if( response.flight_date != '' ) {
					document.querySelector('#flight-date').value = response.flight_date;
				} else {
					document.querySelector('#flight-date').value = "";
				}
				
				if( response.collection_date != '' ) {
					document.querySelector('#collection-date').value = response.collection_date;
				} else {
					document.querySelector('#collection-date').value = "";
				}
			}
}

function checkUserCart(uniqueString) {
	/*********** Check/Get Cart token from cookie if exist already ***********/
	let cartToken = getCookie('cart');
	cartToken = cartToken.split("?");
	cartToken = cartToken[0];
	console.log(cartToken);
	//alert(cartToken);
	/*********** If Cart token exist ***********/
	if( cartToken != '' ) {
		//alert('test5');
		let checkTokenFormData = new FormData();
		checkTokenFormData.append("carttoken", cartToken);
		checkTokenFormData.append("session_cookie", uniqueString);
		checkTokenFormData.append("type", "check-cart-token");
		try {
			fetch(extCartDataURL, { 
				method: 'POST',
				headers: {
					'Accept': 'application/json',
				},
				body: checkTokenFormData
			}).then(response => response.json())
			.then(function (response) {
				checkTokenFormCartData(response, uniqueString);
			}).catch(error => {
				fetch(secondaryCartDataURL, { 
					method: 'POST',
					headers: {
						'Accept': 'application/json',
					},
					body: checkTokenFormData
				}).then(response => response.json())
				.then(function (response) {
					checkTokenFormCartData(response, uniqueString);
				}).catch(error => {
					fetch(thirdCartDataURL, { 
						method: 'POST',
						headers: {
							'Accept': 'application/json',
						},
						body: checkTokenFormData
					}).then(response => response.json())
					.then(function (response) {
						checkTokenFormCartData(response, uniqueString);
					});
				});
			});
		} catch(err) {
			fetch(extCartDataURL, { 
				method: 'POST',
				headers: {
					'Accept': 'application/json',
				},
				body: checkTokenFormData
			}).then(response => response.json())
			.then(function (response) {
				checkTokenFormCartData(response, uniqueString);
			}).catch(error => {
				fetch(secondaryCartDataURL, { 
					method: 'POST',
					headers: {
						'Accept': 'application/json',
					},
					body: checkTokenFormData
				}).then(response => response.json())
				.then(function (response) {
					checkTokenFormCartData(response, uniqueString);
				}).catch(error => {
					fetch(thirdCartDataURL, { 
						method: 'POST',
						headers: {
							'Accept': 'application/json',
						},
						body: checkTokenFormData
					}).then(response => response.json())
					.then(function (response) {
						checkTokenFormCartData(response, uniqueString);
					});
				});
			});
		}
	} else {
		//alert('test10');
		setCookieExpiry('userCookie', uniqueString, 2);
		let checkTokenFormData = new FormData();
		checkTokenFormData.append("carttoken", '');
		checkTokenFormData.append("session_cookie", uniqueString);
		checkTokenFormData.append("type", "check-cart-token");
		try {
			fetch(extCartDataURL, { 
				method: 'POST',
				headers: {
					'Accept': 'application/json',
				},
				body: checkTokenFormData
			}).then(response => response.json())
			.then(function (response) {
				checkTokenFormCartData(response, uniqueString);
			}).catch(error => {
				fetch(secondaryCartDataURL, { 
					method: 'POST',
					headers: {
						'Accept': 'application/json',
					},
					body: checkTokenFormData
				}).then(response => response.json())
				.then(function (response) {
					checkTokenFormCartData(response, uniqueString);
				}).catch(error => {
					fetch(thirdCartDataURL, { 
						method: 'POST',
						headers: {
							'Accept': 'application/json',
						},
						body: checkTokenFormData
					}).then(response => response.json())
					.then(function (response) {
						checkTokenFormCartData(response, uniqueString);
					});
				});
			});
		} catch(err) {
			fetch(extCartDataURL, { 
				method: 'POST',
				headers: {
					'Accept': 'application/json',
				},
				body: checkTokenFormData
			}).then(response => response.json())
			.then(function (response) {
				checkTokenFormCartData(response, uniqueString);
			}).catch(error => {
				fetch(secondaryCartDataURL, { 
					method: 'POST',
					headers: {
						'Accept': 'application/json',
					},
					body: checkTokenFormData
				}).then(response => response.json())
				.then(function (response) {
					checkTokenFormCartData(response, uniqueString);
				}).catch(error => {
					fetch(thirdCartDataURL, { 
						method: 'POST',
						headers: {
							'Accept': 'application/json',
						},
						body: checkTokenFormData
					}).then(response => response.json())
					.then(function (response) {
						checkTokenFormCartData(response, uniqueString);
					});
				});
			});
		}
	}
}

document.addEventListener('ON_CART_UPDATED', function(e) {
	var cartToken = e.detail.cart.token;
	let savedUserCookie = getCookie('userCookie');
	saveCartTokenData.append("type", "save-cart-token");
	saveCartTokenData.append("carttoken", cartToken);
	saveCartTokenData.append("session_cookie", savedUserCookie);
	saveCartData(saveCartTokenData);
});

function validateCheckoutForm() {
	let checkoutButton = document.querySelector('.validate_cart_button');
	let checkoutCreationButton = document.querySelector('.cart__submit');
	let errorModalButton = document.querySelector('.open_cart_error_modal');
	errorModalButton.classList.add("sf-spinner-loading");
	/*var collectionCheckDate  = new Date(collectionDate.value);*/
	/*let pickupLocation = document.querySelectorAll('input.pickup-location[type="radio"]:checked');
	let selectedLocation = document.querySelectorAll('input.pickup-location[type="radio"]');
	for (i = 0; i < selectedLocation.length; i++) {
        if (selectedLocation[i].checked) {
			selectedLocationVal = selectedLocation[i].value;
		}
	}*/
	let travellerName = document.querySelector('#traveller-name');
	let portOfDep = document.querySelector('#port-of-departure');
	let flightNumber = document.querySelector('#flight-number');
	let passportNumber = document.querySelector('#passport-number');
	let phoneNumber = document.querySelector('#phone-number');
	let collectionHour = document.querySelector('#collection-hour');
	let collectionMin = document.querySelector('#collection-minute');
	let flightDate = document.querySelector('#flight-date');
	let collectionDate = document.querySelector('#collection-date');
	
	var collectionCheckDate  = new Date(collectionDate.value);
	var flightCheckDate  = new Date(flightDate.value);
	
	const today = new Date();
	const tomorrow = new Date(today);
	const collectionCheckDateD = new Date(collectionCheckDate);
	const flightCheckDateD = new Date(flightCheckDate);
	tomorrow.setDate(tomorrow.getDate() + 1);
	tomorrow.setHours(0);
	tomorrow.setMinutes(0);
	tomorrow.setSeconds(0);
	tomorrow.setMilliseconds(0);
		
	flightCheckDateD.setHours(0);
	flightCheckDateD.setMinutes(0);
	flightCheckDateD.setSeconds(0);
	flightCheckDateD.setMilliseconds(0);
		
	collectionCheckDateD.setHours(0);
	collectionCheckDateD.setMinutes(0);
	collectionCheckDateD.setSeconds(0);
	collectionCheckDateD.setMilliseconds(0);
		
	var tomorrowDate = tomorrow.toISOString().slice(0, 10);
	var tomorrowDateStrTime = (Date.parse(tomorrowDate) / 1000);
		
	var collectionCheckDateStrTime = (Date.parse(collectionCheckDateD) / 1000);
	var flightCheckDateStrTime = (Date.parse(flightCheckDateD) / 1000);
		
	//console.log(tomorrowDateStrTime);
	//console.log(collectionCheckDateStrTime);
	//console.log(flightCheckDateStrTime);
		
	if (flightCheckDateStrTime < tomorrowDateStrTime){
		var error_display = true;
	}
	if (collectionCheckDateStrTime < tomorrowDateStrTime){
		var error_display = true;
	}
		
	if (flightCheckDate < collectionCheckDate){
		var error_display = true;
	}
	
	/*let pickupLocationSelected = false;
	for(var i = 0; i < pickupLocation.length; i++){
		if(pickupLocation[i].checked){
			pickupLocationSelected = true;
		}
	}
	if( !pickupLocationSelected ) {
		var error_display = true;
	}*/
	
	if( travellerName.value == '' ) {
		var error_display = true;
	}
	if( portOfDep.value == '' ) {
		var error_display = true;
	}
	if( flightNumber.value == '' ) {
		var error_display = true;
	}
	if( passportNumber.value == '' ) {
		var error_display = true;
	}
	if( phoneNumber.value == '' ) {
		var error_display = true;
	}
	if( collectionHour.value == '' ) {
		var error_display = true;
	}
	if( collectionMin.value == '' ) {
		var error_display = true;
	}
	if( flightDate.value == '' ) {
		var error_display = true;
	}
	if( collectionDate.value == '' ) {
		var error_display = true;
	}
	if( error_display ) {
		errorModalButton.click();
		checkoutButton.classList.remove("sf-spinner-loading");
		return false;
	} else {
		checkoutButton.classList.add("sf-spinner-loading");
		saveValidCartData();
		setTimeout(function() {
			checkoutCreationButton.click();
		}, 5000); 
		return false;
	}
}

function saveValidCartData() {
	/*let selectedLocationVal = '';
	let pickupLocation = document.querySelectorAll('input.pickup-location[type="radio"]:checked');
	let selectedLocation = document.querySelectorAll('input.pickup-location[type="radio"]');
	for (i = 0; i < selectedLocation.length; i++) {
        if (selectedLocation[i].checked) {
			selectedLocationVal = selectedLocation[i].value;
		}
	}*/
	
	let travellerName = document.querySelector('#traveller-name');
	let portOfDep = document.querySelector('#port-of-departure');
	let flightNumber = document.querySelector('#flight-number');
	let passportNumber = document.querySelector('#passport-number');
	let phoneNumber = document.querySelector('#phone-number');
	let collectionHour = document.querySelector('#collection-hour');
	let collectionMin = document.querySelector('#collection-minute');
	let flightDate = document.querySelector('#flight-date');
	let collectionDate = document.querySelector('#collection-date');
	
	let cartSToken = getCookie('cart');
	cartSToken = cartSToken.split("?");
	cartSToken = cartSToken[0];
	console.log(cartSToken);
	let savedUserCookie = getCookie('userCookie');
	let saveCartFormData = new FormData();
	
	saveCartFormData.append("carttoken", cartSToken);
	saveCartFormData.append("session_cookie", savedUserCookie);
	saveCartFormData.append("type", 'save-cart-form-data');
		
	/*saveCartFormData.append("pickup_location", selectedLocationVal);*/
	saveCartFormData.append("traveller_name", travellerName.value);
	saveCartFormData.append("port_departure", portOfDep.value);
	saveCartFormData.append("flight_number", flightNumber.value);
	saveCartFormData.append("passport_number", passportNumber.value);
	saveCartFormData.append("phone_number", phoneNumber.value);
	saveCartFormData.append("flight_date", flightDate.value);
	saveCartFormData.append("collection_date", collectionDate.value);
	saveCartFormData.append("collection_hour", collectionHour.value);
	saveCartFormData.append("collection_min", collectionMin.value);
	try {
		fetch(extCartDataURL, { 
			method: 'POST',
			body: saveCartFormData
		}).then(response => { 
			if(response.ok){ return true; } else { return false; } 
		}).catch(error => {
			fetch(secondaryCartDataURL, { 
				method: 'POST',
				body: saveCartFormData
			}).then(response => { 
				if(response.ok){ return true; } else { return false; } 
			}).catch(error => {
				fetch(thirdCartDataURL, { 
					method: 'POST',
					body: saveCartFormData
				}).then(response => { 
					if(response.ok){ return true; } else { return false; } 
				});
			});
		});
	} catch(err) {
		fetch(extCartDataURL, { 
			method: 'POST',
			body: saveCartFormData
		}).then(response => { 
			if(response.ok){ return true; } else { return false; } 
		}).catch(error => {
			fetch(secondaryCartDataURL, { 
				method: 'POST',
				body: saveCartFormData
			}).then(response => { 
				if(response.ok){ return true; } else { return false; } 
			}).catch(error => {
				fetch(thirdCartDataURL, { 
					method: 'POST',
					body: saveCartFormData
				}).then(response => { 
					if(response.ok){ return true; } else { return false; } 
				});
			});
		});
	}
}

function saveCartData(cartData) {
	try {
		fetch(extCartDataURL, { 
			method: 'POST',
			body: cartData
		}).then(response => console.log('success'))
		.catch(error => {
			fetch(secondaryCartDataURL, { 
				method: 'POST',
				body: cartData
			}).then(response => console.log('success'))
			.catch(error => {
				fetch(thirdCartDataURL, { 
					method: 'POST',
					body: cartData
				}).then(response => console.log('success'));
			});
		});
	} catch(err) {
		fetch(extCartDataURL, { 
			method: 'POST',
			body: cartData
		}).then(response => console.log('success'))
		.catch(error => {
			fetch(secondaryCartDataURL, { 
				method: 'POST',
				body: cartData
			}).then(response => console.log('success'))
			.catch(error => {
				fetch(thirdCartDataURL, { 
					method: 'POST',
					body: cartData
				}).then(response => console.log('success'));
			});
		});
	}
	document.querySelector('.cart-form-save-error-wrapper').textContent = '';
	document.querySelector('.cart-form-save-error-wrapper').classList.remove('error');
}

function getCookie(cname) {
	var name = cname + '=';
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}

function setCookie(cname, cvalue) {
	document.cookie = cname + '=' + cvalue + ';path=/';
}

function setCookieExpiry(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	var expires = 'expires=' + d.toUTCString();
	document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function generateUniqueString() {
	const d = new Date();
	let nowTime = d.getTime();
	let assignString = genRandomString(5) +'-'+ nowTime;
	checkSessionFormData.append("session_cookie", assignString);
	checkSessionFormData.append("type", "check-is-unique");
	try {
		fetch(extCartDataURL, { 
			method: 'POST',
			headers: {
				'Accept': 'application/json',
			},
			body: checkSessionFormData
		}).then(response => response.json())
		.then(function (response) {
			if( response.unique == 'yes' ) {
				checkUserCart(assignString)
			} else {
				generateUniqueString();
			}
		}).catch(error => {
			fetch(secondaryCartDataURL, { 
				method: 'POST',
				headers: {
					'Accept': 'application/json',
				},
				body: checkSessionFormData
			}).then(response => response.json())
			.then(function (response) {
				if( response.unique == 'yes' ) {
					checkUserCart(assignString)
				} else {
					generateUniqueString();
				}
			}).catch(error => {
				fetch(thirdCartDataURL, { 
					method: 'POST',
					headers: {
						'Accept': 'application/json',
					},
					body: checkSessionFormData
				}).then(response => response.json())
				.then(function (response) {
					if( response.unique == 'yes' ) {
						checkUserCart(assignString)
					} else {
						generateUniqueString();
					}
				});
			});
		});
	} catch(err) {
		fetch(extCartDataURL, { 
			method: 'POST',
			headers: {
				'Accept': 'application/json',
			},
			body: checkSessionFormData
		}).then(response => response.json())
		.then(function (response) {
			if( response.unique == 'yes' ) {
				checkUserCart(assignString)
			} else {
				generateUniqueString();
			}
		}).catch(error => {
			fetch(secondaryCartDataURL, { 
				method: 'POST',
				headers: {
					'Accept': 'application/json',
				},
				body: checkSessionFormData
			}).then(response => response.json())
			.then(function (response) {
				if( response.unique == 'yes' ) {
					checkUserCart(assignString)
				} else {
					generateUniqueString();
				}
			}).catch(error => {
				fetch(thirdCartDataURL, { 
					method: 'POST',
					headers: {
						'Accept': 'application/json',
					},
					body: checkSessionFormData
				}).then(response => response.json())
				.then(function (response) {
					if( response.unique == 'yes' ) {
						checkUserCart(assignString)
					} else {
						generateUniqueString();
					}
				});
			});
		});
	}
}

function genRandomString(length) {
   let chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
   let charLength = chars.length;
   let result = '';
   for ( let i = 0; i < length; i++ ) {
      result += chars.charAt(Math.floor(Math.random() * charLength));
   }
   return result;
}